<ng-container>
  <form [formGroup]="form">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-item lines="none" [disabled]="emailReadOnly">
            <ion-input
              [value]="form.controls[passwordFormField.email].value"
              [formControlName]="passwordFormField.email"></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-label color="dark" position="stacked">Password</ion-label>
          <ion-item lines="none">
            <ion-icon name="lock-closed-outline" slot="start"></ion-icon>
            <ion-input
              type="password"
              (click)="form.updateValueAndValidity()"
              formControlName="{{ passwordFormField.password }}"
              placeholder="Enter password"
              [type]="passwordInputType"
              [errorText]="getPasswordError(form.controls[passwordFormField.password].errors)"></ion-input>
            @if (!showPassword) {
              <ion-icon
                class="clickable"
                (click)="toggleShowPassword()"
                color="medium"
                name="eye-outline"
                slot="end"></ion-icon>
            }
            @if (showPassword) {
              <ion-icon
                class="clickable"
                (click)="toggleShowPassword()"
                color="medium"
                name="eye-off-outline"
                slot="end"></ion-icon>
            }
          </ion-item>
        </ion-col>
      </ion-row>

      @if (mode === "register") {
        <ion-row>
          <ion-col>
            <ion-label color="dark" position="stacked">Confirm Password</ion-label>
            <ion-item lines="none">
              <ion-icon name="lock-closed-outline" slot="start"></ion-icon>
              <ion-input
                type="password"
                (click)="form.updateValueAndValidity()"
                formControlName="{{ passwordFormField.confirmPassword }}"
                placeholder="Enter password again"
                [type]="passwordInputType"
                [errorText]="getPasswordError(form.controls[passwordFormField.confirmPassword].errors)"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      }
    </ion-grid>
  </form>
</ng-container>
